import {Injectable} from '@angular/core';
import {ServerService} from './ServerService';

/** Itens que podem sair da empresa antes de montar (mesma lista do servidor). */
export type ItemQueSai = 'cardapio' | 'clientes' | 'promocoes' | 'usuarios' | 'integracoes' | 'whatsapp' | 'pagamento' |
  'fiscal' | 'dominio' | 'contrato' | 'estoque';

export interface DadoDaLojaImportado { titulo: string; estado: 'importado' | 'mantido' | 'naoVeio'; detalhe?: string; }

/**
 * Do resultado de uma montagem, campo a campo: entrou, ficou o que já estava preenchido ou o link não trouxe.
 * Montagens antigas não têm veioNoLink: o que não foi aplicado nem mantido aparece como "não veio".
 */
export function dadosDaLojaImportados(resultado: any): DadoDaLojaImportado[] {
  const r = resultado || {};
  const aplicados: string[] = [...(r.dadosAplicados || []), ...(r.imagens || [])];
  const mantidos: string[] = [...(r.dadosMantidos || []), ...(r.veioNoLink || [])];
  const campos: [string, string][] = [['nome', 'Nome'], ['logo', 'Logo'], ['capa', 'Capa'], ['descricao', 'Descrição'],
    ['endereco', 'Endereço'], ['horarios', 'Horários'], ['entrega', 'Entrega e taxa'], ['whatsapp', 'WhatsApp'], ['formas_pagamento', 'Formas de pagamento'], ['subdominio', 'Link da loja']];
  const ligadas = (r.formasLigadas || []).length;
  return campos
    .filter(([campo]) => campo !== 'subdominio' || aplicados.includes(campo) || mantidos.includes(campo))
    .map(([campo, titulo]) => ({titulo,
      estado: aplicados.includes(campo) ? 'importado' : mantidos.includes(campo) ? 'mantido' : 'naoVeio',
      detalhe: campo === 'formas_pagamento' && ligadas ? `${ligadas} ${ligadas === 1 ? 'ligada' : 'ligadas'}` : undefined}));
}

/** Loja a partir de um link (docs/requisito-loja-a-partir-de-link-v1.md): leitura, montagem e acompanhamento. */
@Injectable({providedIn: 'root'})
export class MontagemLojaService extends ServerService {
  /** Lê o link e devolve a prévia com o token (os produtos ficam guardados no servidor). Não grava nada. */
  leia(link: string): Promise<any> { return this.facaPost('/montagem/leia', {link}); }

  situacao(empresaId: number): Promise<any> { return this.obtenha(`/montagem/empresa/${empresaId}/situacao`, {}); }

  marqueDemonstracao(empresaId: number, valor: boolean): Promise<any> {
    return this.facaPost(`/montagem/empresa/${empresaId}/demonstracao`, {valor});
  }

  /** Superadmin: monta numa empresa que já existe (modo montar) ou que acabou de nascer (modo criar). */
  monte(empresaId: number, token: string, modo: 'montar' | 'criar', opcoes: any = {}): Promise<any> {
    return this.facaPost(`/montagem/empresa/${empresaId}`, {token, modo, opcoes});
  }

  /** Primeiros passos: a loja logada completa o que ainda não foi decidido. */
  completeMinhaLoja(token: string): Promise<any> { return this.facaPost('/montagem/minha-loja', {token}); }

  ultimaDaMinhaLoja(): Promise<any> { return this.obtenha('/montagem/minha-loja/ultima', {}); }

  origensDaMinhaLoja(): Promise<any> { return this.obtenha('/montagem/minha-loja/origens', {}); }

  consulte(id: number): Promise<any> { return this.obtenha(`/montagem/${id}`, {}); }

  retome(id: number): Promise<any> { return this.facaPost(`/montagem/${id}/retome`, {}); }

  desista(id: number): Promise<any> { return this.facaPost(`/montagem/${id}/desista`, {}); }
}
